import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../../Services/users.service';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';
import {DealersService} from '../../../Services/dealers.service';
import {TranslateService} from '@ngx-translate/core';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {CollectionDiscount} from '../../../Models/CollectionDiscount';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {DeliveryContact} from '../../../Models/DeliveryContact';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {CollectionTransportationCost} from '../../../Models/CollectionTransportationCost';
import {IButton} from '../../../../shared/card/card.component';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-view-dealer',
  templateUrl: './view-dealer.component.html',
  styleUrls: ['./view-dealer.component.scss']
})
export class ViewDealerComponent implements OnInit {
  public dealerId: number;
  public dealer: any;
  public generalTerm: object[];
  public deliveryId: number;
  public deliveryCompanyName: string;
  public isUserDelete = false;
  public userRoleName;
  public nonAdminUsers;
  public newAdminDealer;
  public archive = false;
  public showDiscountComponent = false;
  public collectionDiscountItems: CollectionDiscount[];
  public collectionDiscounts: CollectionDiscount[];
  public editCollectionDiscount = false;

  /**
   * Start transportation cost section variables
   * ===========================================
   */
  public showTransportationCostComponent = false;
  public collectionTransportationCostItems: CollectionTransportationCost[] = [];
  public collectionTransportationCosts: CollectionTransportationCost[] = [];
  public editCollectionTransportationCost = false;
  public transportationCostDescription?: string;
  /**
   * End transportation cost section variables
   * ===========================================
   */
  public classicBox;
  public lastValue = <any>{};
  public editingUser;
  public refreshModal;
  public showManageDealerUser = false;
  public manageProfile;
  public deliveryUserId: number;
  public users: SystemUser[] = [];
  public deliveryDealer: SystemUser = new SystemUser();
  public dealerUser: any;
  public contactInformation: DeliveryContact;
  public editDeliveryContact = false;
  public userFullname = false;
  public editAdvancedCall = false;
  public editSecondaryAdvancedCall = false;
  public editDefaultDelivery = false;
  public profileOptions = [];
  public currentDealerProfiles = [];
  public canAddAdminUser = false;
  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('transferModel', {static: false}) transferModal = null;
  @ViewChild('readdModal', {static: false}) readdModal = null;
  @ViewChild('editPointModal', {static: false}) editPointModal = null;
  public enableSave = true;
  public userGrid: Grid;
  public contactGrid: Grid;
  public userArchiveGrid: Grid;
  public editStatus = false;
  public editProfile = false;
  public editBundleInvoice = false;
  public statuses = [
    {label: this.translateService.instant('global.active'), value: InvoiceDealer.INVOICEDEALER_ACTIVE},
    {label: this.translateService.instant('global.on_hold'), value: InvoiceDealer.INVOICEDEALER_ON_HOLD},
    {label: this.translateService.instant('global.inactive'), value: InvoiceDealer.INVOICEDEALER_INACTIVE}
  ];
  public yesNoOptions = [
    {label: this.translateService.instant('global.yes'), value: true},
    {label: this.translateService.instant('global.no'), value: false}
  ];
  public defaultDeliveryOptions = [
    {label: this.translateService.instant('doctrine.delivery_contact.primary'), value: 'primary'},
    {label: this.translateService.instant('doctrine.delivery_contact.secondary'), value: 'secondary'}
  ];
  toggleDealerPointClass = 'fa-toggle-on';
  private dateFormat: string;
  public advancedButtons: IButton[] = [];
  public syncButton;
  public transferOrderTo = null;
  public dealerTypeHead = new EventEmitter<string>();
  public dealers: object | boolean = [];
  public noSystemUser = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dealersService: DealersService,
    private deliveryDealersService: UsersService,
    private translateService: TranslateService,
    private auth: AuthenticationService,
    private usersService: UsersService,
    private broadcastService: BroadcastService,
    private dealerProfileService: DealerProfileService,
    private helper: Helper
  ) {
  }

  ngOnInit() {
    this.loadDealers();
    this.syncButton = {
      key: 'sync',
      btnName: this.translateService.instant('admin.exact.sync'),
      method: 'syncWithExact',
      btnCustomClass: 'btn-primary',
      btnIcon: 'fa fa-repeat'
    };

    this.advancedButtons.push(this.syncButton);
    if(this.auth.isBackofficeSuperadmin()) {
      this.advancedButtons.push({
        key: 'transfer',
        btnName: this.translateService.instant('admin.transfer_orders'),
        method: 'openTransferOrderModal',
        btnCustomClass: 'btn-grey',
      });
    }

    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.dealerId = params['id'];
        this.getDealerItem();
      }
    });
    this.getProfilesOptions();

    this.getNonAdminUsers();

    this.dateFormat = this.auth.getDateFormat();

    this.usersService.getDealerEmployees([], {id: this.dealerId}).subscribe(res => {
      this.noSystemUser = res.total === 0;
    });

    this.classicBox = <FormlyFieldConfig>[
      {
        fieldGroupClassName: 'row',
        key: 'dealer',
        fieldGroup: [
          {
            className: 'col-12 ',
            type: 'input',
            key: 'dealerPoints',
            templateOptions: {
              label: this.translateService.instant('doctrine.user.dealer_points'),
              required: true,
              pattern: '^(\\+|-)?\\d+$',
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translateService.instant('errors.invalid'),
                required: this.translateService.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) =>
                  this.translateService.instant('validators.max_message', {limit: field.templateOptions.maxLength})
              }
            }
          }
        ]
      }
    ];

    this.userGrid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.user.name',
          prop: 'fullName',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.username',
          prop: 'username',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.email',
          prop: 'email',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.role',
          prop: 'role',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => this.translateService.instant(row.name)
        },
        <TextColumn>{
          name: 'doctrine.user.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case SystemUser.SYSTEMUSER_ACTIVE:
                return this.translateService.instant('global.active');
              case SystemUser.SYSTEMUSER_INACTIVE:
                return this.translateService.instant('global.inactive');
              case SystemUser.SYSTEMUSER_ON_HOLD:
                return this.translateService.instant('global.on_hold');
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.user.language',
          prop: 'language',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row.name
        },
        <ActionColumn>{
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg ms-1',
              tooltip: 'global.view',
              onclick: row => {
                this.openManageUserModal(row);
              },
              showCallback: row => !this.archive,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg ms-1',
              tooltip: 'global.remove',
              onclick: row => {
                this.userFullname = row.fullName;
                this.userRoleName = row.role.name;
                this.showDeleteModal(row.id, row.fullName, true);
              },
              showCallback: row => !this.archive && row.parent,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-plus fa-lg ms-1',
              tooltip: 'global.remove',
              onclick: row => {
                this.showDeleteModal(row.id, row.name);
              },
              showCallback: row => this.archive,
              btnClass: 'ripple light '
            },
          ]
        },
      ],
      service: this.usersService,
      rememberURL: this.router.url,
      method: 'getDealerEmployees',
      params: {id: this.dealerId},
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };

    this.userArchiveGrid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.user.name',
          prop: 'fullName',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.username',
          prop: 'username',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.email',
          prop: 'email',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.role',
          prop: 'role',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => this.translateService.instant(row.name)
        },
        <TextColumn>{
          name: 'doctrine.user.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case SystemUser.SYSTEMUSER_ACTIVE:
                return this.translateService.instant('global.active');
              case SystemUser.SYSTEMUSER_INACTIVE:
                return this.translateService.instant('global.inactive');
              case SystemUser.SYSTEMUSER_ON_HOLD:
                return this.translateService.instant('global.on_hold');
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.user.language',
          prop: 'language',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row.name
        },
        <ActionColumn>{
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-plus fa-lg ms-1',
              tooltip: 'global.remove',
              onclick: row => {
                this.showReaddModal(row.id, row.fullName);
              },
              showCallback: row => this.archive,
              btnClass: 'ripple light '
            },
          ]
        },
      ],
      service: this.usersService,
      rememberURL: this.router.url,
      method: 'getEmployeeUserArchive',
      params: {id: this.dealerId},
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };

    this.contactGrid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.user.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.category',
          prop: 'contactFunctionTitle',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.email',
          prop: 'email',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.user.mobile_phone_number',
          prop: 'mobile',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
      ],
      service: this.usersService,
      rememberURL: this.router.url,
      method: 'getDealerContacts',
      params: {id: this.dealerId},
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };
  }

  getDealerItem() {
    this.dealersService.getDealer(this.dealerId).subscribe((resp) => {
      if (resp) {
        this.dealer = resp;
        this.lastValue = {dealer: resp};

        this.collectionDiscounts = JSON.parse(JSON.stringify(
          this.dealer.invoiceDealer && this.dealer.invoiceDealer.collectionDiscounts ? this.dealer.invoiceDealer.collectionDiscounts : ''));
        this.editCollectionDiscount = this.collectionDiscounts.length > 0;

        this.collectionTransportationCosts = JSON.parse(JSON.stringify(
          this.dealer.invoiceDealer && this.dealer.invoiceDealer.collectionTransportationCosts ?
            this.dealer.invoiceDealer.collectionTransportationCosts : ''));
        this.editCollectionTransportationCost = this.collectionTransportationCosts.length > 0;

        this.dealer.profiles.forEach((value, key) => {
          this.currentDealerProfiles.push(value.id);
        });

        this.toggleDealerPointClass = this.dealer.dealerPointEnabled ? 'fa-toggle-on' : 'fa-toggle-off';
        return;
      }
      this.router.navigateByUrl('/back-office/crm/dealer/overview');
    });
  }

  getDealer() {
    return InvoiceDealer;
  }

  getDeliveryDealer() {
    return SystemUser;
  }

  showDeleteModal(id, name , isUserDelete = false) {
    this.deliveryId = id;
    this.deliveryCompanyName = name;
    this.isUserDelete = isUserDelete;
    this.deleteModal.show();
  }

  softDelete() {
    this.deliveryDealersService.softDeleteDealer(this.deliveryId).subscribe((res) => {
      this.deleteModal.hide();
      this.refreshGrid();
    });
  }

  softDeleteUser() {
    if(this.isAdminDealer() && !this.newAdminDealer) {
      return;
    }

    this.deliveryDealersService.softDeleteEmployeeUser(this.deliveryId , this.newAdminDealer).subscribe((res) => {
      this.deleteModal.hide();
      this.newAdminDealer = null;
      this.refreshGrid();
    });
  }

  switchShowArchive() {
    this.archive = !this.archive;
    this.refreshGrid();
  }

  showReaddModal(id, name) {
    this.deliveryId = id;
    this.userFullname = name;
    this.readdModal.show();
  }

  readDeliveryDealerUser() {
    this.deliveryDealersService.readdDealerUser(this.deliveryId).subscribe((res) => {
      this.readdModal.hide();
      this.refreshGrid();
    });
  }

  getDateTimeFormatted(datetime) {
    const datetimeMoment = moment(datetime);
    if (datetimeMoment.isValid()) {
      return datetimeMoment.format(this.dateFormat + ' kk:mm');
    }
    return '';
  }

  showDiscountModal() {
    this.showDiscountComponent = true;
    this.collectionDiscountItems = JSON.parse(JSON.stringify(this.dealer.invoiceDealer.collectionDiscounts));
    if (this.collectionDiscountItems.length > 0) {
      this.editCollectionDiscount = true;
    } else {
      this.editCollectionDiscount = false;
    }
  }

  showTransportationCostModal() {
    this.showTransportationCostComponent = true;
    this.collectionTransportationCostItems = JSON.parse(JSON.stringify(this.dealer.invoiceDealer.collectionTransportationCosts || []));
    this.transportationCostDescription = JSON.parse(JSON.stringify(this.dealer.invoiceDealer.transportationCostDescription));
    if (this.collectionTransportationCostItems.length > 0) {
      this.editCollectionTransportationCost = true;
    } else {
      this.editCollectionTransportationCost = false;
    }
  }

  toggleDiscountModal(event) {
    this.showDiscountComponent = event.closeModal;
    if (event.refreshData) {
      this.getDealerItem();
    }
  }

  toggleTransportationCostModal(event) {
    this.showTransportationCostComponent = event.closeModal;
    if (event.refreshData) {
      this.getDealerItem();
    }
  }

  getDealerProfiles(profiles) {
    if (profiles) {
      return profiles.map(profile => profile.name).join(', ');
    }
    return null;
  }

  getPaymentCondition(paymentType) {
    switch (paymentType) {
      case InvoiceDealer.INVOICEDEALER_paymentCondition_14DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.14days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_21DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.21days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_30DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.30days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_PRODUCTION:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.before_production');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_DELIVERY:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.before_delivery');
    }
  }

  showEditPoints() {
    this.editPointModal.show();
  }

  enableButton(event) {
    this.enableSave = event;
  }

  saveDealerPoint() {
    const dealerPoint = {dealerPoints: this.dealer.dealerPoints};
    this.deliveryDealersService.updateDealerPoint(dealerPoint, this.dealerId).subscribe((resp) => {
      this.getDealerItem();
      this.editPointModal.hide();
    });
  }

  openManageUserModal(delivery) {
    this.refreshModal = Math.random();
    this.editingUser = Object.assign({}, delivery);
    this.deliveryUserId = this.dealerId;
    this.showManageDealerUser = true;
  }

  refreshGrid($event = null) {
    const dataToRefresh = this.archive ? this.userArchiveGrid.method : this.userGrid.method;
    this.showManageDealerUser = false;
    this.getNonAdminUsers();
    this.broadcastService.broadcast('refreshDealerGrid', dataToRefresh);
  }

  activateEditStatus() {
    this.editStatus = true;
  }

  activateEditBundleInvoices() {
    this.editBundleInvoice = true;
  }

  saveStatus($event) {
    if (this.editStatus) {
      this.usersService.updateDealerStatus($event.value, this.dealer.id).subscribe(res => {
        this.editStatus = false;
        this.dealer.status = res['status'];
      });
    }
  }

  saveBundleStatus($event) {
    if (this.editBundleInvoice && this.dealer.invoiceDealer) {
      this.usersService.updateDealerBundleInvoice($event.value, this.dealer.invoiceDealer.id).subscribe(res => {
        this.editBundleInvoice = false;
        this.dealer.invoiceDealer.bundleInvoices = res['bundleInvoices'];
      });
    }
  }

  getStatus(status) {
    return this.translateService.instant('global.' + status);
  }

  saveAdvanceCall($event) {
    if (this.editAdvancedCall && this.dealer.deliveryContact) {
      this.usersService.updateDealerAdvancedCall($event.value, this.dealer.deliveryContact.id).subscribe(res => {
        this.editAdvancedCall = false;
        this.dealer.deliveryContact.isAdvancedCall = res['isAdvancedCall'];
      });
    }
    if (this.editSecondaryAdvancedCall && this.dealer.secondaryDeliveryContact) {
      this.usersService.updateDealerAdvancedCall($event.value, this.dealer.secondaryDeliveryContact.id).subscribe(res => {
        this.editSecondaryAdvancedCall = false;
        this.dealer.secondaryDeliveryContact.isAdvancedCall = res['isAdvancedCall'];
      });
    }
  }

  saveDefaultDelivery($event) {
    if (this.editDefaultDelivery && this.dealer) {
      this.usersService.updateDealerDefaultDelivery($event.value, this.dealer.id).subscribe(res => {
        this.editDefaultDelivery = false;
        this.dealer.defaultDelivery = res;
      });
    }
  }

  activateEditAdvanceCall(isSecondary= false) {
    if (isSecondary) {
      this.editSecondaryAdvancedCall = true;
    } else {
      this.editAdvancedCall = true;
    }
  }

  activateEditDefaultDelivery() {
    this.editDefaultDelivery = true;
  }

  getProfilesOptions() {
    this.dealerProfileService.getProfiles().subscribe((resp) => {
      resp.data.forEach((item, key) => {
        this.profileOptions.push({label: item.name, value: item.id});
      });
    });
  }

  activateEditProfile() {
    this.editProfile = true;
  }

  saveProfile($event) {
    if (this.editProfile && this.dealer) {
      this.dealerProfileService.updateDealerProfile($event, this.dealer.id).subscribe(res => {
        this.editProfile = false;
        this.dealer.profiles = res;
      });
    }
  }

  hideModal() {
    this.showManageDealerUser = false;
  }

  changeDealerPointEnableStatus() {
    this.dealer.dealerPointEnabled = !this.dealer.dealerPointEnabled;
    this.toggleDealerPointClass = this.dealer.dealerPointEnabled ? 'fa-toggle-on' : 'fa-toggle-off';
    this.usersService.updateDealerPointStatus(this.dealer.dealerPointEnabled, this.dealer.id).subscribe(res => {
    });
  }

  private getNonAdminUsers() {
    this.usersService.getDealerEmployees('', {id: this.dealerId}).subscribe((res) => {
      this.nonAdminUsers = res.data.filter((item) => item.role.name !== 'admin.dealer.role.admin').map(item => ({label: item.fullName + ` (${item.username})` , value: item.id }));
    });
  }

  isAdminDealer() {
    return this.userRoleName === 'admin.dealer.role.admin';
  }

  syncWithExact() {
    this.syncButton.btnCustomClass = 'btn-grey working';
    this.dealersService.sync(this.dealer.id).subscribe((res) => {
      this.syncButton.btnCustomClass = 'btn-primary';
    }, (e) => {
      this.syncButton.btnCustomClass = 'btn-primary';
    });
  }

  openTransferOrderModal() {
    this.transferOrderTo = null;
    this.transferModal.show();
  }

  closeTransferModal() {
    this.transferOrderTo = null;
    this.transferModal.hide();
  }

  transferOrders() {
    const requestParams = {
      fromId: this.dealerId,
      toId: this.transferOrderTo,
    };

    this.usersService.transferOrders(requestParams).subscribe(res => {
      this.helper.popMessageDialog(
        this.translateService.instant('global.success_message.title'),
        this.translateService.instant('admin.transfer_success_message'),
        'success',
        false
      );
    }, (err) => {
      this.dealers = [];
    });
  }

  loadDealers() {
    this.dealerTypeHead.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      switchMap(term => this.usersService.getDealerUsersDropdown('query=' + term))
    ).subscribe(res => {
      if (res) {
        this.dealers = res;
      }

    }, (err) => {
      this.dealers = [];
    });
  }

  calFunction(method: string) {
    this[method]();
  }
}
